// NCB calls flow through the Quest proxy; secret key never reaches the browser.
const NCB_CONFIG = {
  conversationId: 'chat-234f5fa8-e639-497a-b064-627d5f351035',
  proxyBase: 'https://rmvzorxcl35mttidiexhtp5g2m0hpsqo.lambda-url.us-east-2.on.aws',
  instance: import.meta.env.VITE_NCB_INSTANCE || '48604_human_risk_index_db',
};

// Helper to append instance query param to all requests
function buildProxyUrl(path) {
  const url = new URL(path, NCB_CONFIG.proxyBase);
  if (NCB_CONFIG.instance) {
    url.searchParams.set('Instance', NCB_CONFIG.instance);
  }
  return url.toString();
}

async function ncbRequest(url, options = {}) {
  try {
    const res = await fetch(url, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', ...options.headers },
      ...options,
    });
    const body = await res.json().catch(() => ({}));
    if (!res.ok) {
      return { status: 'error', data: null, error: body?.message || body?.error || `HTTP ${res.status}`, httpStatus: res.status };
    }
    // Data endpoints already return { status, data, metadata }
    if (body && typeof body === 'object' && !Array.isArray(body) && typeof body.status === 'string' && 'data' in body) {
      return body;
    }
    return { status: 'success', data: body };
  } catch (err) {
    return { status: 'error', data: null, error: err?.message || 'Network error' };
  }
}

export async function authFetch(path, options = {}) {
  const url = buildProxyUrl(`/auth/${path}`);
  return ncbRequest(url, options);
}

export async function dataFetch(path, options = {}) {
  const url = buildProxyUrl(`/data/${path}`);
  return ncbRequest(url, options);
}

export async function publicDataFetch(path, options = {}) {
  const url = buildProxyUrl(`/public-data/${path}`);
  return ncbRequest(url, options);
}